import { OnInit } from '@angular/core';
var MidiCreatorComponent = /** @class */ (function () {
    function MidiCreatorComponent() {
    }
    MidiCreatorComponent.prototype.ngOnInit = function () { };
    return MidiCreatorComponent;
}());
export { MidiCreatorComponent };
